import axios from "../../axios-config";
import { artistChartStats, artistStats } from "./artistDetails";

const handleError = (toast, error) => {
    const message = error.response?.data?.message || error.message;
    const status = error.response?.status;

    if ([400, 401, 403, 500].includes(status)) {
        toast.error(message, {
            position: "top-center",
            theme: "colored",
            hideProgressBar: true,
        });
    } else {
        toast.error(message, {
            position: "top-center",
            theme: "colored",
            hideProgressBar: true,
        });
    }
};

export const searchQuery = (details, queryType) => {
    return {
        type: 'SEARCHQUERY',
        queryType: queryType,
        queryDetails: details
    };
}

export const clearSearchQuery = () => ({
  type: 'CLEAR_SEARCH_QUERY'
});

export const startArtistDataBySource = () => {
    return {
        type: 'STARTARTISTBYSOURCE'
    };
}

export const artistDataBySourceFail = () => {
    return {
        type: 'ARTISTBYSOURCEFAIL'
    };
}

export const startPlatformDataBySource = () => {
    return {
        type: 'STARTPLATFORMBYSOURCE'
    };
}

export const platformDataFail = () => {
    return {
        type: 'PLATFORMDATAFAIL'
    }
}

export const trackList = () => {
    return {
        type: 'SEARCHTRACK'
    }
}

export const trackListFails = () => {
    return {
        type: 'SEARCHTRACKFAIL'
    }
}

export const startTrackStats = () => {
    return {
        type: 'STARTTRACKS'
    }
}

export const trackStatsFails = () => {
    return {
        type: 'TRACKSTATSFAIL'
    }
}

export const startTrackStatsForMap = () => {
    return {
        type: 'STARTTRACKSMAP'
    }
}

export const trackStatsFailsForMap = () => {
    return {
        type: 'TRACKSTATSFAILMAP'
    }
}


export const startAudienceDetails = () => {
    return {
        type: 'STARTAUDIENCEDETAILS'
    }
}

export const AudienceDetailsFail = () => {
    return {
        type: 'AUDIENCEDETAILSFAIL'
    }
}

export const startGeoDetails = () => {
    return {
        type: 'STARTGEODETAILS'
    }
}

export const geoDetailsFails = () => {
    return {
        type: 'GEODETAILSFAIL'
    }
}

export const startMilestoneActivities = () => {
    return {
        type: 'STARTMILESTONEACTIVITIES'
    }
}

export const milestoneActivitiesFails = () => {
    return {
        type: 'MILESTONEACTIVITIESFAIL'
    }
}

export const startTrackActivities = () => {
    return {
        type: 'STARTTRACKACTIVITIES'
    }
}

export const trackActivitiesFails = (value) => {
    return {
        type: 'TRACKACTIVITIESFAIL',
        value: value
    }
}

export const startRadioMilestones = () => {
    return {
        type: 'STARTRADIOMILESTONES'
    }
}

export const radioMilestonesFail = () => {
    return {
        type: 'RADIOMILESTONESFAIL'
    }
}

export const startRadioTrackStats = () => {
    return {
        type: 'STARTRADIOTRACKSTATS'
    }
}

export const radioTrackStatsFail = () => {
    return {
        type: 'RADIOTRACKSTATSFAIL'
    }
}

export const startRadioGeoStats = () => {
    return {
        type: 'STARTRADIOGEOSTATS'
    }
}

export const radioGeoStatsFail = () => {
    return {
        type: 'RADIOGEOSTATSFAIL'
    }
}

export const artistStatsBySource = (details) => {
    return {
        type: 'GETARTISTSTATSBYSOURCE',
        stats: details
    }
}

export const getArtistStatsBySources = (toast,queryParams,setIsLoading) => {
    return async (dispatch) => {
        setIsLoading(true)
        dispatch(startArtistDataBySource());
        try {
            const authCode = "Bearer " + localStorage.getItem('authToken');
            const response = await axios.get('/data-analyst/v1/get-artist-stats-by-source', {
                headers: { Authorization: authCode },
                params: queryParams
            });
            dispatch(artistStatsBySource(response.data.data.all_data));
            setIsLoading(false)
        } catch (error) {
            dispatch(artistDataBySourceFail());
            handleError(toast, error);
        }
    };
};


export const artistChartStatsBySource = (details) => {
    return {
        type: 'GETARTISTCHARTSTATSBYSOURCE',
        stats: details
    }
}

export const getArtistChartStatsBySource = (toast,queryParams) => {
    return async (dispatch) => {
        dispatch(startArtistDataBySource());
        try {
            const authCode = "Bearer " + localStorage.getItem('authToken');
            const response = await axios.get('/data-analyst/v1/get-artist-chart-by-source', {
                headers: { Authorization: authCode },
                params: queryParams
            });
            dispatch(artistChartStatsBySource(response.data.data));
        } catch (error) {
            dispatch(artistDataBySourceFail());
            handleError(toast, error);
        }
    };
};

export const platformStatsBySource = (details) => {
    return {
        type: 'PLATFORMSTATSBYSOURCE',
        stats: details
    }
}

export const getPlatformStatsBySource = (toast,queryParams, setIsLoading) => {
    return async (dispatch) => {
        setIsLoading(true)
        dispatch(startPlatformDataBySource());
        try {
            const authCode = "Bearer " + localStorage.getItem('authToken');
            const response = await axios.get('/data-analyst/v1/get-platform-stats-by-source', {
                headers: { Authorization: authCode },
                params: queryParams
            });
            dispatch(platformStatsBySource(response.data.data.all_data));
            setIsLoading(false)
        } catch (error) {
            dispatch(platformDataFail());
            handleError(toast, error);
        }
    };
};

export const platformChartsBySource = (details) => {
    return {
        type: 'PLATFORMCHARTSBYSOURCE',
        stats: details
    }
}

export const getPlatformChartsBySource = (toast,queryParams) => {
    return async (dispatch) => {
        dispatch(startPlatformDataBySource());
        try {
            const authCode = "Bearer " + localStorage.getItem('authToken');
            const response = await axios.get('/data-analyst/v1/get-platform-charts-by-source', {
                headers: { Authorization: authCode },
                params: queryParams
            });
            dispatch(platformChartsBySource(response.data.data.all_data));
        } catch (error) {
            dispatch(platformDataFail());
            handleError(toast, error);
        }
    };
};

export const allTracks = (details) => {
    return {
        type: 'ALLTRACKS',
        tracks: details
    }
}

export const searchTrack = (toast,queryParams,setIsLoading) => {
    return async (dispatch) => {
        setIsLoading(true)
        dispatch(trackList());
        try {
            const authCode = "Bearer " + localStorage.getItem('authToken');
            const response = await axios.get('/data-analyst/v1/search-track', {
                headers: { Authorization: authCode },
                params: queryParams
            });
            dispatch(allTracks(response.data.data));
            setIsLoading(false)
        } catch (error) {
            dispatch(trackListFails());
            handleError(toast, error);
        }
    };
};

export const trackStats = (details) => {
    return {
        type: 'TRACKSTATS',
        stats: details
    }
}

export const getTrackStats = (toast,queryParams,forArtist) => {
    return async (dispatch) => {
        dispatch(startTrackStats());
        try {
            const authCode = "Bearer " + localStorage.getItem('authToken');
            const response = await axios.get('/data-analyst/v1/get-track-stats', {
                headers: { Authorization: authCode },
                params: queryParams
            });
            if(forArtist){
                dispatch(artistStats(response.data.data.all_data))
            } else {
                dispatch(trackStats(response.data.data.all_data));
            }
        } catch (error) {
            dispatch(trackStatsFails());
            handleError(toast, error);
        }
    };
};

export const trackStatsForMap = (details) => {
    return {
        type: 'TRACKSTATSFORMAP',
        stats: details
    }
}

export const getTrackStatsForMap = (toast,queryParams) => {
    return async (dispatch) => {
        dispatch(startTrackStatsForMap());
        try {
            const authCode = "Bearer " + localStorage.getItem('authToken');
            const response = await axios.get('/data-analyst/v1/get-track-stats', {
                headers: { Authorization: authCode },
                params: queryParams
            });
            dispatch(trackStatsForMap(response?.data?.data?.all_data));
        } catch (error) {
            dispatch(trackStatsFailsForMap());
            handleError(toast, error);
        }
    };
};

export const trackCharts = (details) => {
    return {
        type: 'TRACKCHARTS',
        stats: details
    }
}

export const getTrackChartsStats = (toast,queryParams,forArtist) => {
    return async (dispatch) => {
        dispatch(startTrackStats());
        try {
            const authCode = "Bearer " + localStorage.getItem('authToken');
            const response = await axios.get('/data-analyst/v1/get-track-charts', {
                headers: { Authorization: authCode },
                params: queryParams
            });
            if(forArtist){
                dispatch(artistChartStats(response.data.data.all_data || response.data.data.yearly_data))
            } else {
                dispatch(trackCharts(response.data.data.all_data || response.data.data.yearly_data));
            }
        } catch (error) {
            dispatch(trackStatsFails());
            handleError(toast, error);
        }
    };
};

export const audienceDetails = (details) => {
    return {
        type: 'AUDEINCEDATA',
        stats: details
    }
}

export const getAudienceDetails = (toast,queryParams,setIsLoading) => {
    return async (dispatch) => {
        setIsLoading(true)
        dispatch(startAudienceDetails());
        try {
            const authCode = "Bearer " + localStorage.getItem('authToken');
            const response = await axios.get('/data-analyst/v1/get-audience-details', {
                headers: { Authorization: authCode },
                params: queryParams
            });
            dispatch(audienceDetails(response.data.data));
            setIsLoading(false)
        } catch (error) {
            dispatch(AudienceDetailsFail());
            handleError(toast, error);
        }
    };
};

export const geoDetails = (details) => {
    return {
        type: 'GEODATA',
        stats: details
    }
}

export const getGeoDetails = (toast,queryParams) => {
    return async (dispatch) => {
        dispatch(startGeoDetails());
        try {
            const authCode = "Bearer " + localStorage.getItem('authToken');
            const response = await axios.get('/data-analyst/v1/get-geo-details', {
                headers: { Authorization: authCode },
                params: queryParams
            });
            dispatch(geoDetails(response.data.data));
        } catch (error) {
            dispatch(geoDetailsFails());
            handleError(toast, error);
        }
    };
};

export const milestoneActivities = (details) => {
    return {
        type: 'MILESTONEDATA',
        stats: details
    }
}

export const playlistActivities = (details) => {
    return {
        type: 'PLAYLISTDATA',
        stats: details
    }
}

export const getMilestoneActivities = (toast,queryParams,type,setIsLoading) => {
    return async (dispatch) => {
        dispatch(startMilestoneActivities());
        if (typeof setIsLoading === 'function') setIsLoading(true)
        try {
            const authCode = "Bearer " + localStorage.getItem('authToken');
            const response = await axios.get('/data-analyst/v1/get-milestone-activities', {
                headers: { Authorization: authCode },
                params: queryParams
            });
            // Build payload including pagination metadata
            const payload = {
                data: response.data.data || [],
                offset: response.data.offset ?? null,
                nextOffset: response.data.nextOffset ?? null,
                limit: response.data.limit ?? null,
                hasMore: response.data.hasMore ?? false,
                // default scope for radio data coming from radio-milestones endpoint
                scope: undefined,
            };

            if(type === 'MILESTONE') {
                dispatch(milestoneActivities(payload));
            } else if (type === 'PLAYLIST') {  
                dispatch(playlistActivities(payload));
            }
            if (typeof setIsLoading === 'function') setIsLoading(false)
        } catch (error) {
            dispatch(milestoneActivitiesFails());
            handleError(toast, error);
        }
    };
};

export const trackActivities = (details) => {
    return {
        type: 'TRACKACTIVITIES',
        stats: details
    }
}

export const radioMilestones = (details) => {
    return {
        type: 'RADIOMILESTONESDATA',
        stats: details
    }
}

export const radioData = (details) => {
    return {
        type: 'RADIODATA',
        stats: details
    }
}

export const getTrackActivities = (toast,queryParams,type,setIsLoading) => {
    return async (dispatch) => {
        dispatch(startTrackActivities());
        if (typeof setIsLoading === 'function') setIsLoading(true)
        try {
            const authCode = "Bearer " + localStorage.getItem('authToken');
            const response = await axios.get('/data-analyst/v1/get-tracks-activities', {
                headers: { Authorization: authCode },
                params: queryParams
            });

            const payload = {
                data: response.data.data || [],
                offset: response.data.offset ?? null,
                nextOffset: response.data.nextOffset ?? null,
                limit: response.data.limit ?? null,
                hasMore: response.data.hasMore ?? false,
            };

            // dispatch into the same reducers that handle pagination merging
            if(type === 'MILESTONE') {
                dispatch(milestoneActivities(payload));
            } else if (type === 'PLAYLIST') {  
                dispatch(playlistActivities(payload));
            } else if (type === 'RADIO'){
                dispatch(radioData(payload));
            } else if (type === 'RADIO_MILESTONE'){
                // mark radio track-scoped payload so reducer can decide whether to append or replace
                payload.scope = 'track';
                dispatch(radioMilestones(payload));
            }
            if (typeof setIsLoading === 'function') setIsLoading(false)
        } catch (error) {
            dispatch(trackActivitiesFails('fails'));
            handleError(toast, error);
        }
    };
};

export const getRadioMilestones = (toast,queryParams, setIsLoading) => {
    return async (dispatch) => {
        if (typeof setIsLoading === 'function') setIsLoading(true)
        dispatch(startRadioMilestones());
        try {
            const authCode = "Bearer " + localStorage.getItem('authToken');
            const response = await axios.get('/data-analyst/v1/get-radio-milestones', {
                headers: { Authorization: authCode },
                params: queryParams
            });

            const payload = {
                data: response.data.data || [],
                offset: response.data.offset ?? null,
                nextOffset: response.data.nextOffset ?? null,
                limit: response.data.limit ?? null,
                hasMore: response.data.hasMore ?? false,
            };

            // mark radio payload as radio-scope
            payload.scope = 'radio';
            dispatch(radioMilestones(payload));
            if (typeof setIsLoading === 'function') setIsLoading(false)
        } catch (error) {
            dispatch(radioMilestonesFail());
            handleError(toast, error);
            if (typeof setIsLoading === 'function') setIsLoading(false)
        }
    };
};

export const radioGeoStats = (details) => {
    return {
        type: 'RADIOGEOSTATS',
        stats: details
    }
}

export const getRadioGeoStats = (toast,queryParams) => {
    return async (dispatch) => {
        dispatch(startRadioGeoStats());
        try {
            const authCode = "Bearer " + localStorage.getItem('authToken');
            const response = await axios.get('/data-analyst/v1/get-radio-audience', {
                headers: { Authorization: authCode },
                params: queryParams
            });
            dispatch(radioGeoStats(response.data.data));
        } catch (error) {
            dispatch(radioGeoStatsFail());
            handleError(toast, error);
        }
    };
};

